module.exports = __webpack_public_path__ + "img/logo_text.cbe7d929.svg";